require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./courses-code-401-advanced-software-development-for-mobile-applications.json") })
        }
      }, "path---courses-code-401-advanced-software-development-for-mobile-applications");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---courses-code-401-advanced-software-development-for-mobile-applications!./.cache/json/courses-code-401-advanced-software-development-for-mobile-applications.json
// module id = 1188
// module chunks = 231608221292675